import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { z } from "zod";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Pill, Search } from "lucide-react";

export const Route = createFileRoute("/pharmacy/")({
  component: Pharmacy,
});

function Pharmacy() {
  const [q, setQ] = useState("");
  const { data, isLoading } = useQuery({
    queryKey: ["drugs", q],
    queryFn: () => apiFetch(`/api/pharmacy/drugs?q=${encodeURIComponent(q)}`, { schema: z.object({ items: z.array(z.any()) }) }),
  });

  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <Pill className="h-5 w-5" /> Pharmacie
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Catalogue INN aligné Maroc · Stocks · Dispensations</p>
      </div>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="DCI (INN), ATC, marque..." value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" />
      </div>
      <Card>
        <CardHeader><CardTitle>Catalogue</CardTitle></CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="text-sm text-muted-foreground">Chargement...</div>
          ) : (
            <ul className="space-y-2">
              {data?.items.map((d: any) => (
                <li key={d.id} className="flex items-center justify-between rounded-md border border-white/5 bg-white/[0.02] p-3">
                  <div>
                    <div className="font-medium">{d.inn}</div>
                    <div className="text-xs text-muted-foreground">{d.atc} · {d.dosage} {d.form}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    {d.controlled && <Badge variant="destructive">Stup.</Badge>}
                    <Badge variant="outline">Stock {d.stockQty}</Badge>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
